import {
  Component,
  HostBinding,
  input,
  Input,
  InputSignal,
  signal,
  WritableSignal,
} from '@angular/core';
import { BaseWidget } from '../base-widget/base-widget';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'divider',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './divider.component.html',
  styleUrl: './divider.component.scss',
})
export class Divider extends BaseWidget {
  @HostBinding('class') @Input() ngClass: any;
  @HostBinding('style') @Input() ngStyle: any;

  @Input() actionEvent: (event: any) => void;
  slot: InputSignal<any> = input();
  cssClassMap: Map<number, String> = new Map();
  cssStylesMap: Map<number, any> = new Map();
  data: WritableSignal<any> = signal(null);

  ngOnInit(): void {
    this.data.set(this.slot()?.widget?.data);
    this.slot()?.widget?.data?.renderableComponents?.forEach(
      (e: any, index: number) => {
        this.cssClassMap.set(index, this.getClass(e.widgetAttributes));
        this.cssStylesMap.set(index, this.getStyles(e.widgetAttributes));
      },
    );
  }
}
